// extracted by mini-css-extract-plugin
export default {"container":"styles_container__9gjhB","label":"styles_label__LxgL2","value":"styles_value__GFncW"};